<div class="dsh-wrap">
  <header class="dsh-head">
    <div class="dsh-title-row">
      <span class="dsh-title-icon"><i [class]="icon"></i></span>
      <h1 class="dsh-title">{{ title }}</h1>
    </div>
    <p class="dsh-subtitle">{{ subtitle }}</p>
  </header>

  <div class="dsh-grid">
    @for (c of cards; track c.label) {
      <a class="dsh-card" [routerLink]="c.link">
        <span class="dsh-card-icon" [class.orange]="c.accent === 'orange'"><i [class]="c.icon"></i></span>
        <span class="dsh-card-body">
          <span class="dsh-card-label">{{ c.label }}</span>
          <span class="dsh-card-desc">{{ c.description }}</span>
        </span>
        <i class="dsh-card-arrow fa fa-angle-right"></i>
      </a>
    }
  </div>
</div>
